import { useState } from 'react';
import { IconButton, Typography } from 'seagull';
import { Close14, WideArrowBackward, WideArrowForward } from 'seagull/icons';
import styles from "./SeeWhatItsLike.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const handleIndexChange = (newIndex, totalItems) => {
  if (newIndex >= totalItems) return 0;
  if (newIndex < 0) return totalItems - 1;
  return newIndex;
};
export default function Modal(_ref) {
  let {
    steps,
    testPrefix,
    onClose
  } = _ref;
  const [currentIndex, setCurrentIndex] = useState(0);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.modalRoot,
    children: [/*#__PURE__*/_jsx(IconButton, {
      className: styles.closeButton,
      onClick: onClose,
      children: /*#__PURE__*/_jsx(Close14, {})
    }), /*#__PURE__*/_jsx(IconButton, {
      testId: "".concat(testPrefix, "-btn-back"),
      className: styles.arrowBackward,
      onClick: () => {
        setCurrentIndex(handleIndexChange(currentIndex - 1, steps.length));
      },
      children: /*#__PURE__*/_jsx(WideArrowBackward, {})
    }), steps.map((_ref2, idx) => {
      let {
        title,
        subtitle,
        image: {
          src,
          altText,
          width,
          height
        }
      } = _ref2;
      return /*#__PURE__*/_jsxs("figure", {
        className: styles.figure,
        children: [/*#__PURE__*/_jsx("img", {
          style: {
            opacity: currentIndex === idx ? 1 : 0
          },
          src: src,
          alt: altText,
          "data-testid": currentIndex === idx ? "".concat(testPrefix, "-img") : undefined,
          "aria-hidden": currentIndex !== idx,
          width: width,
          height: height
        }), /*#__PURE__*/_jsxs("figcaption", {
          className: styles.caption,
          style: {
            visibility: currentIndex === idx ? 'visible' : 'hidden'
          },
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Typography, {
              as: "p",
              testId: currentIndex === idx ? "".concat(testPrefix, "-title") : undefined,
              variant: "h5",
              skin: "invertedStandard",
              children: title
            }), typeof subtitle === 'string' ? /*#__PURE__*/_jsx(Typography, {
              as: "p",
              testId: currentIndex === idx ? "".concat(testPrefix, "-subtitle") : undefined,
              skin: "invertedStandard",
              children: subtitle
            }) : /*#__PURE__*/_jsx("div", {
              "data-testid": currentIndex === idx ? "".concat(testPrefix, "-subtitle") : undefined,
              children: subtitle
            })]
          }), /*#__PURE__*/_jsxs(Typography, {
            className: styles.counter,
            testId: currentIndex === idx ? "".concat(testPrefix, "-counter") : undefined,
            skin: "invertedStandard",
            children: [currentIndex + 1, "/", steps.length]
          })]
        })]
      }, src);
    }), /*#__PURE__*/_jsx(IconButton, {
      testId: "".concat(testPrefix, "-btn-forward"),
      className: styles.arrowForward,
      onClick: () => {
        setCurrentIndex(handleIndexChange(currentIndex + 1, steps.length));
      },
      children: /*#__PURE__*/_jsx(WideArrowForward, {})
    })]
  });
}